export const WaterfallImages = [
    {
        id:1,
        url:'https://images.pexels.com/photos/831088/pexels-photo-831088.jpeg',
        text:"1. Chitrakoot Falls, Chhattisgarh",
        Info:"These falls are located near Bastar in Chhattisgarh. River Indravati flows from the Vindhya Range, and enters Andhra Pradesh through Chhattisgarh. It is known to be the widest waterfalls in India, Also Read - Royal Hotels in Rajasthan: 5 Luxurious Stays For That Exotic Regal Experience - Rajasthan Tourism!",
        label:'see details',
        btn:'Book Now',
        path:'/waterfall/1',
    },
    {
        id:2,
        url:'https://images.pexels.com/photos/1353239/pexels-photo-1353239.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
        text:"2. Shivanasamudra Falls, Karnataka",
        Info:"Located in Karnataka. These twin waterfalls flow from river Kaveri. 322 ft in height, this is where Asia’s first (and still functioning) hydro-electric plant was set up.",
        label:'see details',
        btn:'Book Now',
        path:'/waterfall/2',
    },
    {
        id:3,
        url:'https://images.pexels.com/photos/1262803/pexels-photo-1262803.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
        text:"3. Dudhsagar Falls, Goa",
        Info:"Located on the Goa-Karnataka border, the four-tiered Dudhsagar falls are a part of the river Mandovi. There is a railway station called the Castle Rock station, from where you can board a train and get off at Dudhsagar stop. You won’t find a station platform here, instead get off the steep ladder and walk for about one kilometer to reach these magnificent falls.",
        label:'see details',
        btn:'Book Now',
        path:'/waterfall/3',
    },
    {
        id:4,
        url:"https://www.tripsavvy.com/thmb/xOoa0I3gZ0nfPMGMn2KsEZN0elo=/2000x2000/smart/filters:no_upscale()/GettyImages-141296615-aafce3a8534c45aba8afd312fa155cea.jpg",
        text:"4.  Athirapally Falls, Kerala",
        Info:"The Chalakudy river originates from the Anamudi mountains and falls near Athirapally, giving the waterfall its name. It is one of the most beautiful waterfalls in Kerala and is often referred to as the Niagara of India.",
        label:'see details',
        btn:'Book Now',
        path:'/waterfall/4',
        
    },
    
]
// export const WaterfallImages2 =[
//     {
//         id2:4,
//         url:"https://www.tripsavvy.com/thmb/xOoa0I3gZ0nfPMGMn2KsEZN0elo=/2000x2000/smart/filters:no_upscale()/GettyImages-141296615-aafce3a8534c45aba8afd312fa155cea.jpg",
//         text:"4.  Athirapally Falls, Kerala",
//         Info:"The Chalakudy river originates from the Anamudi mountains and falls near Athirapally, giving the waterfall its name. It is one of the most beautiful waterfalls in Kerala and is often referred to as the Niagara of India.",
//         label:'see details',
//         path:'/waterfall/4',
        
//     },
//     {
//         id2:5,
//         url:"https://s3.india.com/travel/wp-content/uploads/2017/06/Jog-Falls.jpg",
//         text:"5. Jog Falls, Karnataka",
//         label:'see details',
//         path:'/waterfall/5',

//     }
// ]